import { RequestOptions } from 'bernie-graphql';
import { FetchOptions } from 'bernie-core';

import { SearchCriteriaStore } from 'src/stores';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getParam(query: any, paramKey: string): string[] {
  return Object.keys(query).filter(key => paramKey === key);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function generateRequestOptions(request: any, isServer: boolean, pageId: string): RequestOptions {
  const { traceInfo, deviceId } = request.context;

  const options: RequestOptions = {
    pageId: pageId,
    extraHeaders: { 'Device-User-Agent-ID': deviceId }
  };

  if (isServer) {
    options.traceId = (traceInfo && traceInfo['Trace-ID']) || null;
  }

  return options;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function needSearchFis(query: any, forceFetch: boolean): boolean {
  //bernie has these hard-coded, so we need to do the same for now
  const dialogRouteKeys = ['pwaDialog', 'pwaDialogNested', 'pwaOverlay'];
  const { prevQuery, ...currentQuery } = query;

  const prevParamsDialogs = Object.keys(prevQuery).filter(key => dialogRouteKeys.includes(key));
  const currentParamsDialogs = Object.keys(currentQuery).filter(key => dialogRouteKeys.includes(key));
  const isClosingDialog = currentParamsDialogs.length < prevParamsDialogs.length;
  const isOpeningDialog = currentParamsDialogs.length > prevParamsDialogs.length;
  const fetchTriggeredByDialog = isClosingDialog || isOpeningDialog;

  return !fetchTriggeredByDialog || (isClosingDialog && forceFetch);
}

export function needSearchFsr(options: FetchOptions, searchCriteriaStore?: SearchCriteriaStore): boolean {
  const { query } = options;

  //bernie has these hard-coded, so we need to do the same for now
  const dialogRouteKeys = ['pwaDialog', 'pwaDialogNested', 'pwaOverlay'];
  const { prevQuery, ...currentQuery } = query;
  const prevParamsDialogs = Object.keys(prevQuery).filter(key => dialogRouteKeys.includes(key));
  const currentParamsDialogs = Object.keys(currentQuery).filter(key => dialogRouteKeys.includes(key));
  const isClosingDialog = currentParamsDialogs.length < prevParamsDialogs.length;
  const isOpeningDialog = currentParamsDialogs.length > prevParamsDialogs.length;
  const fetchTriggeredByDialog = isClosingDialog || isOpeningDialog;

  if (!isOpeningDialog) {
    searchCriteriaStore.setCriteriaFromUrl(options);
  }

  return !fetchTriggeredByDialog || (isClosingDialog && searchCriteriaStore.forceFetch);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function needSearchBasisOnInfoKeys(query: any): boolean {
  const identifierKey = 'identifier';
  const jcidKey = 'journeyContinuationId';
  const { prevQuery, ...currentQuery } = query;
  let fetchTriggeredByInfoKeys = true;

  if (query && query.journeyContinuationId && query.identifier) {
    const prevParamIdentifier = getParam(prevQuery, identifierKey);
    const currentParamIdentifier = getParam(currentQuery, identifierKey);
    const prevParamJcid = getParam(prevQuery, jcidKey);
    const currentParamJcid = getParam(currentQuery, jcidKey);
    const withIdentifierCall = currentParamIdentifier.length >= prevParamIdentifier.length;
    const withJcidCall = currentParamJcid.length > prevParamJcid.length;
    fetchTriggeredByInfoKeys = !withIdentifierCall || withJcidCall;
  }

  return fetchTriggeredByInfoKeys;
}
